// extracted by mini-css-extract-plugin
module.exports = {"FooterWrapper":"Footer_FooterWrapper__2MJkD","Logos":"Footer_Logos__s3HF3"};